const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        credentials: 'include',
    });

    if (response.status === 401) {
        console.error('Authentication expired or failed for:', url);
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(errorData.detail || errorData.message || 'API request failed');
    }

    return response.json();
};

// Calendar Events API
export const fetchCalendarEvents = async (familyId, filters = {}) => {
    const params = new URLSearchParams();
    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== null) {
            params.append(key, filters[key]);
        }
    }
    const queryString = params.toString();
    return fetchWithAuth(`/v1/families/${familyId}/calendar_events${queryString ? `?${queryString}` : ''}`);
};

export const getCalendarEvent = async (familyId, eventId) => {
    return fetchWithAuth(`/v1/families/${familyId}/calendar_events/${eventId}`);
};

export const createCalendarEvent = async (familyId, eventData) => {
    return fetchWithAuth(`/v1/families/${familyId}/calendar_events`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(eventData),
    });
};

export const updateCalendarEvent = async (familyId, eventId, eventData) => {
    return fetchWithAuth(`/v1/families/${familyId}/calendar_events/${eventId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(eventData),
    });
};

export const deleteCalendarEvent = async (familyId, eventId) => {
    return fetchWithAuth(`/v1/families/${familyId}/calendar_events/${eventId}`, {
        method: 'DELETE',
    });
};

